"use client";

import { useEffect, useState } from "react";
import { Menu } from "@headlessui/react";
import Lucy from "@/icons/lucy.svg";
import AngleDown from "@/icons/angleDown.svg";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { getTranslation } from "@/i18n/get-translation";
import { convertUrlString } from "@/utils/convert-url-string";

interface IHeader {
  locale: string;
  whiteBgHeader?: boolean;
  isErrorPage?: boolean;
  logoHref?: string;
}
export default function ScheduleHeader({ locale, isErrorPage = false, logoHref }: IHeader) {
  const t = getTranslation(locale, "header");

  const pathname = usePathname();
  const [isScrolled, setIsScrolled] = useState<boolean>(false);

  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);

  const handleScroll = () => {
    window.scrollY > 10 ? setIsScrolled(true) : setIsScrolled(false);
  }

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  });

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const renderActiveLanguage = () => {
    switch(pathname.substring(0, 3)) {
      case "/en": return t("en");
      case "/de": return t('de');
      case "/fr": return t("fr");
    }
  }

  return (
    <header
      className={`inset-x-0 z-50 text-base md:text-xl fixed top-0 left-0 w-full transition-all bg-transparent ${
        isScrolled || isErrorPage
          ? ` bg-white shadow-[0_0.625rem_1.0625rem_rgba(0,4,254,0.1)]`
          : `shadow-none`
      }`}
      id="top"
    >
      <div className="max-w-[1630px] mx-auto">
        <nav
          className="flex items-center p-4 lg:px-20 relative z-40"
          aria-label="Global"
        >
          <div className="flex">
            <a href={logoHref ? logoHref : pathname} className="">
              <Lucy className="w-[6.563rem] max-md:w-[5rem]" />
            </a>
          </div>
          <div className="relative ml-auto">
            <Menu>
              <Menu.Button className="flex items-center text-inherit hover:opacity-80 aria-expanded:opacity-80 w-12 h-12 justify-center">
                {renderActiveLanguage()}
                <AngleDown className="mt-1 ml-2 w-[0.75rem] md:w-[0.875rem]" />
              </Menu.Button>
              <Menu.Items className="absolute right-0 py-1 px-3 bg-white rounded border-2 border-primary-400 flex flex-col">
                {pathname.substring(0, 3) !== "/en" && (
                  <Menu.Item>
                    <Link className="w-12 h-12 justify-center flex items-center" href={`/en-lu${convertUrlString(pathname)}`}>
                      {t("en")}
                    </Link>
                  </Menu.Item>
                )}
                {pathname.substring(0, 3) !== "/de" && (
                  <Menu.Item>
                    <Link className="w-12 h-12 justify-center flex items-center" href={`/de-lu${convertUrlString(pathname)}`}>
                      {t("de")}
                    </Link>
                  </Menu.Item>
                )}
                {pathname.substring(0, 3) !== "/fr" && (
                  <Menu.Item>
                    <Link className="w-12 h-12 justify-center flex items-center" href={`/fr-lu${convertUrlString(pathname)}`}>
                      {t("fr")}
                    </Link>
                  </Menu.Item>
                )}
              </Menu.Items>
            </Menu>
          </div>
        </nav>
        </div>
    </header>
  );
}
